import axios from 'axios'
import { useCallback, useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'

interface C001IdTokenGetProps {
  execIdTokenGet: (
    loginId: string,
    password?: string | undefined,
    email?: string,
  ) => Promise<Result>
  loading: loadStatus
}
// C001 IDトークン取得API呼出
export const useC001IdTokenGet = (): C001IdTokenGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const execIdTokenGet = useCallback(async (loginId: string, password?: string, email?: string) => {
    try {
      setLoading(loadStatus.LOADING)
      // ヘッダ作成
      const header = axiosDefaultHeader
      // ボディ作成
      const body = password
        ? { login_id: loginId, password: password }
        : { login_id: loginId, email: email }
      // console.log(body);
      // C001 IDトークン取得API
      const response = await axios.post(`${baseUrl}${stage}${apiUrl.authPath}`, body, {
        headers: header,
        validateStatus: () => true,
      })

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true, message: response.data.token }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.AUTH_ERROR }
    }
  }, [])

  return { execIdTokenGet, loading }
}
